import React from "react";
import vmAmbienti from "../../Global/images/vm_ambienti1.png";
import vmChillFrozen from "../../Global/images/vm_chill_frozen.png";
import vmLockerStandAlone from "../../Global/images/vmLockerStandAlone.png";
import vm_chill_frozen_indufrial from "../../Global/images/vm_chill_frozen_indufrial.png";

const MachinesForWingTypeImages = ({ wingType, soClient }) => {
  console.log("aaaa",soClient);
  const IMAGES_SWITCH = {
    0: () => soClient === "INDUFRIAL S.A." ? (
      <img src={vm_chill_frozen_indufrial} id="vendingMachine" alt="" width={260} height={150} style={{padding: '30px 0px 10px'}} />
    ) : (
      <img src={vmAmbienti} id="vendingMachine" alt="" width={220} height={120} style={{padding: '30px 0px 10px'}} />
    ),
    1: () =>  soClient === "INDUFRIAL S.A." ? (
      <img src={vm_chill_frozen_indufrial} id="vendingMachine" alt="" width={260} height={150} style={{padding: '30px 0px 10px'}} />
    ) : (
      <img src={vmChillFrozen} id="vendingMachine" alt="" width={290} height={220} style={{padding: '30px 0px 10px'}} />
    ),
    2: () =>  soClient === "INDUFRIAL S.A." ? (
      <img src={vm_chill_frozen_indufrial} id="vendingMachine" alt="" width={260} height={150} style={{padding: '30px 0px 10px'}}/>
    ) : (
      <img src={vmChillFrozen} id="vendingMachine" alt="" width={290} height={220} style={{padding: '30px 0px 10px'}} />
    ),
    3: () => <img src={vmLockerStandAlone} id="locker" alt="" width={290} height={300} style={{padding: '20px'}}/>,
    4: () => soClient === "INDUFRIAL S.A." ? (
      <img src={vm_chill_frozen_indufrial} id="vendingMachine" alt="" width={260} height={150} style={{padding: '30px 0px 10px'}} />
    ) : (
      <img src={vmAmbienti} id="vendingMachine" alt="" width={220} height={120} style={{padding: '30px 0px 10px'}} />
    ),
  };
  function wingTypeSelection() {
    if (wingType) {
      return <div> {IMAGES_SWITCH[wingType.id]()}</div>;
    }
    return <div />;
  }
  return wingTypeSelection();
};

export default MachinesForWingTypeImages;
